import type { Nullable } from "@core/domain/types/nullable.type";
import type { Undefinable } from "@core/domain/types/undefinable.type";
import { BaseViewModel } from "@iot-platform/core";
import type { Notebook } from "@notebook/domain/models/notebook.model";
import { NotebookGetByIdUseCase } from "@notebook/domain/usecases/notebook-get-by-id.usecase";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class NotebookPageViewmodel extends BaseViewModel {
    @observable
    initialLoading = true;

    @observable
    notebook: Nullable<Readonly<Notebook>> = null;

    @observable
    notebookId: Undefinable<string> = undefined;

    constructor(
        @inject(NotebookGetByIdUseCase)
        private readonly notebookGetByIdUseCase: NotebookGetByIdUseCase,
    ) {
        super();
        makeObservable(this);
    }

    @action
    override async didMount(): Promise<void> {
        await this.initViewData();
    }

    async initViewData(): Promise<void> {
        await this.fetchNotebook();
        runInAction(() => {
            this.initialLoading = false;
        });
    }

    @action
    async fetchNotebook(): Promise<void> {
        if (!this.notebookId) throw new Error("notebookId is missing");

        const notebook = await this.notebookGetByIdUseCase.execute(
            this.notebookId,
        );
        runInAction(() => {
            this.notebook = notebook;
        });
    }
}
